<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
            </section>
            <section class="widget">
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <inputCustom [titulo]="'Ciclo'" [disabled]="true" [(ngModel)]="entidad.ciclo" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nombre del periodo de evaluación'" [disabled]="true" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <inputCustom [titulo]="'Tipo de evaluación'" [disabled]="true" [(ngModel)]="accion.accion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nivel'" [disabled]="true" [(ngModel)]="accion.entidad.nivel" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                </div>

                <dx-tab-panel [animationEnabled]="true" [height]="800">
                  <dxi-item title="Materias">
                        <asignacionevaluacionpadres_materias #general
                        [id]="id"
                        [idnivel]="accion.entidad.nivel"
                        [idtipoevaluacion]="accion.entidad.tipoevaluacionid"
                        [periodoevaluacionportipoevaluacionid]="accion.entidad.periodoevaluacionportipoevaluacionid"
                        [identificador]="identificador"
                        (output)="formulario()"
                        (prevista)="cargarprevisualizacion($event)">
                        </asignacionevaluacionpadres_materias>
                    </dxi-item>
                    <dxi-item title="Colaboradores">
                      <div></div>
                        <asignacionevaluacionpadres_colaborador *ngIf="entidad.periodoevaluacionid"
                        [nivel]="accion.entidad.nivel"
                        [cicloid]="entidad.cicloid"
                        [nivelid]="accion.entidad.nivelid"
                        [periodoevaluacionid]="entidad.periodoevaluacionid"
                        [periodoevaluacionportipoevaluacionid]="accion.entidad.periodoevaluacionportipoevaluacionid"
                        [tipoevaluacionid]="accion.entidad.tipoevaluacionid"
                        [identificador]="identificador"
                        (prevista)="cargarprevisualizacion($event)">
                        </asignacionevaluacionpadres_colaborador>
                    </dxi-item>
                </dx-tab-panel>

                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()">
                            <span> {{'Cancelar'}}</span>
                        </button>
                            <div class="divisorH16 " ></div>
                            <button matTooltip="Guardar" class="boton botonSM filled" [class.disabled]="visualizar"
                            (click)="Guardar()"
                            *ngIf="sistemaService.permisos.agregar">
                            <span> {{'Guardar'}}</span>
                        </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div #asignacionevaluacionpadresform></div>

<div #containerEvaluacion></div>
